exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".my-event[data-v-06ac5d90]{overflow:hidden;text-overflow:ellipsis;white-space:nowrap;border-radius:2px;background-color:#1867c0;color:#fff;border:1px solid #1867c0;width:100%;font-size:12px;padding:3px;cursor:pointer;margin-bottom:1px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-06ac5d90","scoped":true,"hasInlineConfig":false}!./node_modules/stylus-loader!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/administration/leave_entry/eventCalendar.vue
// module id = 1304
// module chunks = 3